import React from 'react'

const Sport = () => {
  return (
    <div>Sport</div>
  )
}

export default Sport